/* Strada254 Everyday theme. Cards + product page share one variant picker.
   Checkout is always Shopify's own: "Buy now" uses a cart permalink, the
   cart drawer submits to /cart with name="checkout". */
(() => {
  const S = window.Strada || { routes: { root: '/' }, strings: {} };
  const root = S.routes.root.endsWith('/') ? S.routes.root : `${S.routes.root}/`;

  /* ---------- helpers ---------- */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const toast = (msg) => {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toast.t);
    toast.t = setTimeout(() => el.classList.remove('is-visible'), 2400);
  };
  const postJSON = (url, body) =>
    fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(async (r) => {
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Cart error');
      return data;
    });

  /* ---------- cart drawer ---------- */
  const drawer = () => $('[data-cart-drawer]');
  const openCart = () => {
    const d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $('.drawer__panel', d)?.focus();
  };
  const closeCart = () => {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  const renderCart = (sections) => {
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-drawer]', doc);
    const current = drawer();
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    const count = fresh ? (fresh.querySelector('[data-cart-count-label]')?.textContent || '').trim().split(' ')[0] : null;
    if (count !== null) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.classList.toggle('is-empty', count === '0');
      });
    }
  };
  const addToCart = (id, quantity = 1) =>
    postJSON(S.routes.cartAdd, { items: [{ id, quantity }], sections: 'cart-drawer', sections_url: window.location.pathname })
      .then((data) => {
        renderCart(data.sections);
        openCart();
      })
      .catch((e) => toast(e.message));

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer() && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeCart();
      return;
    }
    const qty = e.target.closest('[data-qty-change]');
    if (qty && drawer()?.contains(qty)) {
      const line = qty.closest('[data-line]');
      const lineNo = line ? Number(line.dataset.line) : null;
      if (lineNo) {
        postJSON(S.routes.cartChange, { line: lineNo, quantity: Number(qty.dataset.qtyChange), sections: 'cart-drawer', sections_url: window.location.pathname })
          .then((data) => renderCart(data.sections))
          .catch((err) => toast(err.message));
      }
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      $('[data-filters]')?.classList.remove('is-open');
    }
  });

  /* ---------- variant picker (cards + product page) ---------- */
  const initPicker = (card) => {
    if (card.dataset.ready) return;
    card.dataset.ready = '1';
    const json = $('[data-variants]', card);
    const variants = json ? JSON.parse(json.textContent) : [];
    if (!variants.length) return;
    const isPdp = card.hasAttribute('data-pdp');
    const sizeIdx = Number(card.dataset.sizeIndex);
    const colorIdx = Number(card.dataset.colorIndex);
    const single = !!$('[data-single]', card);
    const first = variants.find((v) => v.available) || variants[0];

    // start from the first available variant; size must be chosen by the shopper
    const state = first.options.slice();
    const preselectedSize = $$(`[data-option="${sizeIdx}"].is-selected`, card)[0];
    if (sizeIdx >= 0) state[sizeIdx] = preselectedSize ? preselectedSize.dataset.value : null;
    const selectedColor = $$(`[data-option="${colorIdx}"].is-selected`, card)[0];
    if (colorIdx >= 0 && selectedColor) state[colorIdx] = selectedColor.dataset.value;

    const buyBtn = $('[data-buy]', card);
    const buyLabel = $('[data-buy-label]', card);
    const addBtn = $('[data-add]', card);
    const hint = $('[data-hint]', card);
    const idInput = $('[data-variant-id]', card);

    const match = () => variants.find((v) => v.options.every((o, i) => state[i] === null || state[i] === undefined || o === state[i]) && state.every((s) => s !== null));
    const needsSize = () => sizeIdx >= 0 && !state[sizeIdx] && !single;
    // best variant for the chosen colour, used to show that colour's photo before a size is picked
    const colourVariant = () => {
      if (colorIdx < 0 || !state[colorIdx]) return null;
      const same = variants.filter((v) => v.options[colorIdx] === state[colorIdx]);
      return same.find((v) => v.available && (v.media || v.img)) || same.find((v) => v.media || v.img) || same[0] || null;
    };
    const cardImg = isPdp ? null : $('.card__media img', card);
    const cardLinks = isPdp ? [] : $$('a[href]', card).filter((a) => a.getAttribute('href').split('?')[0] === card.dataset.productUrl);
    const showCardVariant = (cv) => {
      if (!cv) return;
      if (cardImg && cv.img && !cardImg.src.startsWith(cv.img.split('&width=')[0])) {
        cardImg.srcset = [320, 480, 720].map((w) => `${cv.img.replace(/width=\d+/, `width=${w}`)} ${w}w`).join(', ');
        cardImg.src = cv.img;
      }
      cardLinks.forEach((a) => { a.href = `${card.dataset.productUrl}?variant=${cv.id}`; });
    };

    let touched = false;
    const refresh = () => {
      // availability of sizes for the chosen colour
      if (sizeIdx >= 0) {
        $$(`[data-option="${sizeIdx}"]`, card).forEach((chip) => {
          const ok = variants.some((v) => v.available && v.options[sizeIdx] === chip.dataset.value && (colorIdx < 0 || v.options[colorIdx] === state[colorIdx]));
          chip.classList.toggle('is-unavailable', !ok);
        });
      }
      const v = single ? variants[0] : match();
      const sizeText = sizeIdx >= 0 && state[sizeIdx] ? ` · ${state[sizeIdx]}` : '';
      const sold = v && !v.available;
      if (buyLabel) buyLabel.textContent = sold ? S.strings.soldOut : `${S.strings.buyNow}${sizeText}`;
      if (buyBtn) buyBtn.disabled = !!sold;
      if (addBtn) addBtn.disabled = !!sold;
      if (v && idInput) idInput.value = v.id;
      if (isPdp && v) {
        const price = $('[data-price] .price__now', card);
        if (price && v.price) price.textContent = v.price;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
      const cv = v || colourVariant();
      if (isPdp && cv && cv.media) showMedia(card, cv.media);
      if (!isPdp && touched) showCardVariant(cv);
      const sizeName = $('[data-size-name]', card);
      if (sizeName) sizeName.textContent = state[sizeIdx] || '';
      return v;
    };

    const nudge = () => {
      card.classList.remove('needs-size');
      void card.offsetWidth;
      card.classList.add('needs-size');
      if (hint) hint.hidden = false;
    };

    card.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-option]');
      if (opt && card.contains(opt)) {
        const idx = Number(opt.dataset.option);
        state[idx] = opt.dataset.value;
        $$(`[data-option="${idx}"]`, card).forEach((el) => {
          const on = el === opt;
          el.classList.toggle('is-selected', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (idx === colorIdx) {
          touched = true;
          const name = $('[data-color-name]', card);
          if (name) name.textContent = opt.dataset.value;
        }
        if (hint) hint.hidden = true;
        card.classList.remove('needs-size');
        refresh();
        return;
      }
      if (e.target.closest('[data-buy]')) {
        e.preventDefault();
        if (needsSize()) return nudge();
        const v = single ? variants[0] : match();
        if (v) window.location.href = `${root}cart/${v.id}:1`;
        return;
      }
      if (e.target.closest('[data-add]') && !isPdp) {
        e.preventDefault();
        if (needsSize()) return nudge();
        const v = single ? variants[0] : match();
        if (v) addToCart(v.id).then(() => $('[data-add]', card)?.classList.add('is-added'));
      }
    });

    const form = $('[data-product-form]', card);
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (needsSize()) return nudge();
        const v = single ? variants[0] : match();
        if (v) addToCart(v.id);
      });
    }
    refresh();
  };

  const showMedia = (scope, id) => {
    const target = $(`[data-media="${id}"]`, scope);
    if (!target) return;
    $$('[data-media]', scope).forEach((el) => { el.hidden = el !== target; });
    $$('[data-media-thumb]', scope).forEach((el) => el.classList.toggle('is-active', el.dataset.mediaThumb === String(id)));
  };
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-media-thumb]');
    if (thumb) showMedia(thumb.closest('[data-pdp]') || document, thumb.dataset.mediaThumb);
  });

  const initAll = (ctx = document) => $$('[data-product-card]', ctx).forEach(initPicker);

  /* ---------- tabs (best sellers) ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tab]');
    if (!tab) return;
    const wrap = tab.closest('[data-tabs]');
    $$('[data-tab]', wrap).forEach((t) => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-panel]', wrap).forEach((p) => { p.hidden = p.dataset.panel !== tab.dataset.tab; });
  });

  /* ---------- collection: sort, filters, load more ---------- */
  const isMobile = () => window.matchMedia('(max-width: 960px)').matches;
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-autosubmit]')) {
      const form = document.getElementById(e.target.getAttribute('form'));
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      return;
    }
    const form = e.target.closest('[data-autosubmit-form]');
    if (form && !isMobile() && e.target.type !== 'number') {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-autosubmit-form]');
    if (!form) return;
    // drop empty fields so URLs stay clean
    $$('input, select', form).forEach((el) => { if (!el.value) el.disabled = true; });
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-filters-open]')) $('[data-filters]')?.classList.add('is-open');
    if (e.target.closest('[data-filters-close]')) $('[data-filters]')?.classList.remove('is-open');
    const more = e.target.closest('[data-load-more]');
    if (more) {
      e.preventDefault();
      more.setAttribute('aria-busy', 'true');
      fetch(more.href)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = $('[data-products-grid]');
          const items = $$('[data-products-grid] > *', doc);
          items.forEach((el) => grid.appendChild(el));
          initAll(grid);
          const nextNav = $('.pagination', doc);
          const nav = more.closest('.pagination');
          if (nav) nav.replaceWith(nextNav || document.createElement('span'));
          window.history.replaceState({}, '', more.href);
        })
        .catch(() => { window.location.href = more.href; });
    }
  });

  /* ---------- product recommendations ---------- */
  const loadRecommendations = () => {
    $$('[data-recommendations]').forEach((el) => {
      if (el.children.length) return;
      fetch(el.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = $('[data-recommendations]', doc);
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            initAll(el);
          }
        })
        .catch(() => {});
    });
  };


  /* ---------- product description: clamp with read more ---------- */
  const initDesc = (ctx = document) => $$('[data-desc]', ctx).forEach((desc) => {
    const btn = desc.parentElement.querySelector('[data-desc-toggle]');
    if (!btn || desc.scrollHeight <= desc.clientHeight + 40) {
      desc.classList.add('is-open');
      return;
    }
    desc.classList.add('is-clamped');
    btn.hidden = false;
    btn.addEventListener('click', () => {
      const open = desc.classList.toggle('is-open');
      btn.textContent = open ? window.Strada.strings.readLess : window.Strada.strings.readMore;
      if (!open) desc.closest('details').scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  });

  /* ---------- predictive search: suggestions update as the shopper types ---------- */
  const initPredictive = () => {
    const input = $('[data-predictive-input]');
    const box = $('[data-predictive-results]');
    if (!input || !box || !S.routes.predictiveSearch) return;
    const form = input.closest('form');
    const cache = new Map();
    let timer;
    let ctrl;
    let active = -1;

    const items = () => $$('[data-predictive-item]', box);
    const open = () => { box.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const close = () => {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    };
    const setActive = (i) => {
      const list = items();
      if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach((el, n) => {
        el.classList.toggle('is-active', n === active);
        el.id = el.id || `ps-item-${n}`;
      });
      input.setAttribute('aria-activedescendant', list[active].id);
      list[active].scrollIntoView({ block: 'nearest' });
    };
    const render = (html) => {
      box.innerHTML = html;
      active = -1;
      open();
    };
    const query = (term) => {
      if (cache.has(term)) return render(cache.get(term));
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      box.setAttribute('aria-busy', 'true');
      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'query,product,collection',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,tag,vendor',
      });
      fetch(`${S.routes.predictiveSearch}?${params}`, { signal: ctrl.signal })
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const body = doc.querySelector('[data-predictive-body]');
          const html = body ? body.outerHTML : '';
          cache.set(term, html);
          if (input.value.trim() === term) render(html);
        })
        .catch(() => {})
        .finally(() => box.removeAttribute('aria-busy'));
    };

    input.addEventListener('input', () => {
      const term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { close(); return; }
      timer = setTimeout(() => query(term), 160);
    });
    input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); items()[active].click(); }
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initAll();
    initDesc();
    initPredictive();
    loadRecommendations();
  });
  document.addEventListener('shopify:section:load', (e) => { initAll(e.target); initDesc(e.target); });
})();
